import { Link } from 'react-router';
import { FileText } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import type { DashboardAssignmentItem } from '@/types/assignment';
import { formatDate } from '@/lib/utils';

const statusVariant: Record<string, 'default' | 'secondary' | 'destructive'> = {
  completed: 'default',
  pending: 'secondary',
  expired: 'destructive',
};

interface AssignmentsTableProps {
  assignments: DashboardAssignmentItem[];
}

export function AssignmentsTable({ assignments }: AssignmentsTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Practice</TableHead>
            <TableHead>Student</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Assigned</TableHead>
            <TableHead>Due Date</TableHead>
            <TableHead>Completed</TableHead>
            <TableHead>Report</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {assignments.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} className="text-center text-muted-foreground">
                No assignments found.
              </TableCell>
            </TableRow>
          ) : (
            assignments.map((a) => (
              <TableRow key={a.id}>
                <TableCell className="font-medium">
                  <Link
                    to={`/seeds/${a.practice_seed_id}`}
                    className="hover:underline"
                  >
                    {a.practice_title}
                  </Link>
                </TableCell>
                <TableCell>
                  <Link
                    to={`/students/${a.student_id}`}
                    className="hover:underline"
                  >
                    {a.student_name}
                  </Link>
                </TableCell>
                <TableCell>
                  <Badge variant={statusVariant[a.status] ?? 'secondary'}>{a.status}</Badge>
                </TableCell>
                <TableCell>{formatDate(a.assigned_at)}</TableCell>
                <TableCell>{a.due_date ? formatDate(a.due_date) : '—'}</TableCell>
                <TableCell>{a.completed_at ? formatDate(a.completed_at) : '—'}</TableCell>
                <TableCell>
                  {a.report_id ? (
                    <Link
                      to={`/reports/${a.report_id}`}
                      className="inline-flex items-center gap-1 text-primary hover:underline"
                    >
                      <FileText className="h-4 w-4" />
                      View
                    </Link>
                  ) : (
                    '—'
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
